import React from 'react'
import AppointmentListItem from './AppointmentListItem'

function AppointmentList({ appointmentList,checkedItems,handleCheckboxChange,handleAllSelect,isAllSelected}) {
  return (
    <div className="table-responsive">
                          <table className="table table-hover align-middle gs-0 gy-4">
                            <thead>
                              <tr>
                                <th className="w-25px">
                                  <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="select all" onClick={(e)=>{handleAllSelect(e)}}/>
                                  </div>
                                </th>
                                <th className="min-w-150px">Time</th>
                                <th className="min-w-150px">Info</th>
                                <th className="min-w-150px"></th>
                                <th className="min-w-150px"></th>
                                <th className="text-end min-w-100px">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                             {appointmentList.map(appt=>{
                               return <AppointmentListItem key={appt.appointmentId} appt={appt} handleCheckboxChange={handleCheckboxChange} isAllSelected={isAllSelected}/> })}
                            </tbody>
                            </table>
                          </div>
  )
}

export default AppointmentList